import { render, staticRenderFns } from "./EditNextSteps.vue?vue&type=template&id=4dc7502a&"
import script from "./EditNextSteps.vue?vue&type=script&lang=ts&"
export * from "./EditNextSteps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc7502a')) {
      api.createRecord('4dc7502a', component.options)
    } else {
      api.reload('4dc7502a', component.options)
    }
    module.hot.accept("./EditNextSteps.vue?vue&type=template&id=4dc7502a&", function () {
      api.rerender('4dc7502a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/discharge/EditNextSteps.vue"
export default component.exports